<div class="wrapper">
  <div class="media-large">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Status</th>
          <th scope="col">Details</th>
          <th scope="col">Amount</th>
          <th scope="col">Order</th>
          <!-- <th scope="col">Authorization code</th> -->
          <th scope="col">Comments</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor='let h of history'>
          <td>{{h.date | date: 'mediumDate'}}</td>
          <td>Paid</td>
          <td><a class="link_a" data-bs-toggle="modal" data-bs-target="#exampleModalCenter"
              (click)='selectedHistory=h; selectHistory()'>View the receipt</a></td>
          <td>{{h.amount}} AMD</td>
          <td>{{h.tranasctionId}}</td>
          <!-- <td>256467</td> -->
          <td>{{h.comment}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="media-small">
    <table class="table">
      <thead class="media-thead">
        <tr>
          <th scope="col">{{'transactions.inqDate' | translate}}</th>
          <th scope="col">{{'transactions.amount' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor='let h of history'>
          <th>{{h.date}}</th>
          <td>{{h.amount}}</td>
          <td>
            <svg (click)='selectedHistory=h; selectHistory()' data-bs-toggle="modal"
              data-bs-target="#exampleModalCenter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="612px" height="612px"
              viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" xml:space="preserve">
              <g>
                <g id="_x39__6_">
                  <g>
                    <path d="M38.25,535.5v-153H0v153C0,577.747,34.253,612,76.5,612h153v-38.25h-153C55.367,573.75,38.25,556.633,38.25,535.5z
                      M0,76.5v153h38.25v-153c0-21.114,17.117-38.25,38.25-38.25h153V0h-153C34.253,0,0,34.253,0,76.5z M573.75,535.5
                      c0,21.133-17.117,38.25-38.25,38.25h-153V612h153c42.247,0,76.5-34.253,76.5-76.5v-153h-38.25V535.5z M535.5,0h-153v38.25h153
                      c21.133,0,38.25,17.136,38.25,38.25v153H612v-153C612,34.253,577.747,0,535.5,0z" />
                  </g>
                </g>
              </g>
            </svg>
          </td>
        </tr>

      </tbody>
    </table>
    <div class="modal fade" id="moreIformation" tabindex="-1" role="dialog" aria-labelledby="moreIformationLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title" id="moreIformationLabel">Receipt</h1>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button> -->
          </div>
          <div *ngIf='selectedHistory.merchantInfo' class="modal-body">
            {{selectedHistory.merchantInfo.companyName}}
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>

</div>








<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Receipt</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div *ngIf='selectedHistory.merchantInfo' class="modal-body">
        <div class="recipt">
          <div class="image">
            <img src="{{selectedHistory.merchantInfo.logo}}" alt="">
          </div>
          <div class="info">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Amount</th>
                  <th scope="col">Details</th>
                  <th scope="col">Order</th>
                  <th scope="col">Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{selectedHistory.amount}}</td>
                  <td>{{selectedHistory.date | date: 'mediumDate'}}</td>
                  <td>{{selectedHistory.tranasctionId}}</td>
                  <td>{{selectedHistory.comment == ''? 'No Comment' : selectedHistory.comment}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
